import SocialIcon from './SocialIcon'

export * from './SocialIcon'

export default SocialIcon
